/* src/app/timecard/time-card-presenter/time-card-presenter.component.scss */
:root {
  --timecard-cell-bg-default: var(--p-datatable-row-background, var(--p-surface-0, #ffffff));
  --timecard-cell-color-default: var(--p-datatable-row-color, var(--p-text-color, #000000));
  --timecard-cell-bg-disabled: var(--p-datatable-row-striped-background, #a3a3a3);
  --timecard-cell-color-disabled: var(--p-datatable-row-color, var(--p-text-color, #000000));
  --timecard-cell-bg-user-signed: var(--p-primary-50, #e3f2fd);
  --timecard-cell-color-user-signed: var(--p-primary-700, #1976d2);
  --timecard-cell-bg-user-saved: var(--p-purple-50, #f3e5f5);
  --timecard-cell-color-user-saved: var(--p-purple-700, #7b1fa2);
  --timecard-cell-bg-superuser-signed: var(--p-green-50, #e8f5e9);
  --timecard-cell-color-superuser-signed: var(--p-green-700, #388e3c);
  --timecard-cell-bg-superuser-saved: var(--p-orange-50, #fff3e0);
  --timecard-cell-color-superuser-saved: var(--p-orange-700, #f57c00);
}
#tabTimeCard .tabulator-row .tabulator-cell.disabledTimeCardCell {
  opacity: 0.9 !important;
  background: linear-gradient(rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), var(--timecard-cell-bg-disabled) !important;
}
#tabTimeCard .tabulator-row .tabulator-cell.disabledTimeCardCell:not([style*=background-color]) {
  background: linear-gradient(rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), var(--timecard-cell-bg-disabled) !important;
  color: var(--timecard-cell-color-disabled) !important;
}
.tabulator-cell.timecard-cell-role-based {
}
.tabulator-cell.timecard-cell-default {
  background-color: var(--timecard-cell-bg-default) !important;
  color: var(--timecard-cell-color-default) !important;
}
.tabulator-cell.timecard-cell-primeng-default {
  background-color: var(--p-datatable-row-background, var(--p-surface-0, #ffffff)) !important;
  color: var(--p-datatable-row-color, var(--p-text-color, #000000)) !important;
}
.tabulator-cell.timecard-cell-task-only {
  background-color: var(--p-datatable-row-background, var(--p-surface-0, #ffffff)) !important;
  color: var(--p-datatable-row-color, var(--p-text-color, #000000)) !important;
}
.tabulator-cell.timecard-cell-user-signed {
  background-color: var(--timecard-cell-bg-user-signed) !important;
  color: var(--timecard-cell-color-user-signed) !important;
}
.tabulator-cell.timecard-cell-user-saved {
  background-color: var(--timecard-cell-bg-user-saved) !important;
  color: var(--timecard-cell-color-user-saved) !important;
}
.tabulator-cell.timecard-cell-superuser-signed {
  background-color: var(--timecard-cell-bg-superuser-signed) !important;
  color: var(--timecard-cell-color-superuser-signed) !important;
}
.tabulator-cell.timecard-cell-superuser-saved {
  background-color: var(--timecard-cell-bg-superuser-saved) !important;
  color: var(--timecard-cell-color-superuser-saved) !important;
}
.tabulator-cell.default-cursor {
  cursor: default !important;
}
#tabTimeCard .tabulator-row .tabulator-cell:not(.disabledTimeCardCell):not([style*=background-color]) {
  background-color: var(--timecard-cell-bg-default) !important;
  color: var(--timecard-cell-color-default) !important;
}
#tabTimeCard .tabulator-footer .tabulator-calcs-holder .tabulator-row .tabulator-cell,
#tabTimeCard .tabulator-calcs .tabulator-cell,
#tabTimeCard .tabulator-calcs-bottom .tabulator-cell {
  background-color: unset !important;
  color: unset !important;
  padding: 0.1rem 0.2rem !important;
}
#tabTimeCard .tabulator-footer .tabulator-calcs-holder .tabulator-row,
#tabTimeCard .tabulator-calcs .tabulator-row,
#tabTimeCard .tabulator-calcs-bottom .tabulator-row {
  padding: 0.1rem 0 !important;
}
.tabulator-cell:not(.disabledTimeCardCell):hover {
  filter: brightness(0.95);
}
.tabulator-cell:focus {
  outline: 2px solid var(--p-primary-color);
  outline-offset: -2px;
}
#tabTimeCard .tabulator-row .tabulator-cell[tabulator-field=task] {
  text-align: left !important;
}
#tabTimeCard {
  background-color: var(--surface-card) !important;
  border-radius: var(--border-radius);
  border: 1px solid var(--surface-border);
  min-height: 300px;
}
#tabWeeklySummary {
  background-color: var(--surface-card) !important;
  border-radius: var(--border-radius);
  border: 1px solid var(--surface-border);
}
#tabManagement {
  background-color: var(--surface-card) !important;
  border-radius: var(--border-radius);
  border: 1px solid var(--surface-border);
}
html.app-dark .timecard-tabulator {
  background-color: #272727 !important;
  border-radius: var(--border-radius);
  padding: 0.75rem;
}
html:not(.app-dark) .timecard-tabulator {
  background-color: #ececec !important;
  border-radius: var(--border-radius);
  padding: 0.75rem;
}
.week-navigation-header {
  background: var(--surface-card);
  border-radius: var(--border-radius);
  padding: 0.5rem;
  border: 1px solid var(--surface-border);
}
.week-navigation-header h3 {
  color: var(--text-color);
  font-weight: 600;
}
.timecard-footer {
  background: var(--surface-card);
  border-radius: var(--border-radius);
  padding: 0.75rem 1rem;
  border: 1px solid var(--surface-border);
}
#tabWeeklySummary {
  width: 100% !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
}
.weeklySummaryGrid {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}
.weeklySummaryGridColumn {
  width: 100%;
  max-width: 100%;
}
.weekly-summary-title {
  text-decoration: underline;
}
#tabTimeCard .tabulator-headers .tabulator-col {
  height: 4rem !important;
  align-content: center !important;
}
#tabWeeklySummary .tabulator-headers .tabulator-col {
  height: 3rem !important;
  align-content: center !important;
}
.tabulator-edit-box input[type=number]::-webkit-outer-spin-button,
.tabulator-edit-box input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  display: none !important;
}
.tabulator-edit-box input[type=number] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}
::ng-deep .tabulator input[type=number]::-webkit-outer-spin-button,
::ng-deep .tabulator input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  display: none !important;
}
::ng-deep .tabulator input[type=number] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  display: none !important;
}
input[type=number] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}
.direct-report-cards {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 5px;
}
.timecard-layout {
  display: flex;
  gap: 1rem;
  align-items: stretch;
  min-height: 0 !important;
  max-height: none !important;
  flex: 1 1 auto;
}
.outer {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.timecard-main {
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: 3.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
}
.timecard-tabs-row {
  flex: 0 0 auto;
  width: 100%;
}
.mgmt-command-bar {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1rem;
  padding: 0.65rem 0.85rem;
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
}
.mgmt-period-field {
  min-width: 16rem;
}
.mgmt-command-option {
  white-space: nowrap;
  font-size: 0.875rem;
}
.mgmt-action-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}
.mgmt-command-feedback,
.mgmt-command-hint {
  margin-left: auto;
}
.mgmt-command-hint {
  max-width: 22rem;
}
.manager-workspace {
  gap: 0.75rem;
}
.dr-queue-header {
  padding: 0.35rem 0.25rem 0.5rem;
}
.dr-queue-title {
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--text-color);
}
.manager-timecard-stage {
  width: 100%;
}
.timecard-bottom {
  position: sticky;
  bottom: 0;
  z-index: 3;
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  padding: 0.5rem;
  margin-top: 0.5rem;
}
.timecard-bottom .weekly-summary-panel {
  margin-top: 0;
}
.timecard-bottom .legend {
  margin-top: 0.5rem;
  width: 100%;
}
.timecard-layout-left {
  flex: 0 0 540px;
  width: 540px;
  max-width: 40%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  align-self: stretch;
  background: var(--surface-100);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  padding: 0.5rem;
}
.directReportGrid {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
.timecard-layout-left .p-accordion,
.timecard-layout-left .p-accordion-panel,
.timecard-layout-left .p-accordion-content {
  flex: 1 1 auto;
  min-height: 0;
}
.timecard-layout-right {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: var(--surface-100);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  padding: 0.5rem;
}
.timecard-layout-right .timeCardGrid,
.timecard-layout-right .p-accordion,
.timecard-layout-right .p-accordion-panel,
.timecard-layout-right .p-accordion-content {
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
}
.direct-report-panel {
  flex: 1 1 auto;
  min-height: 0;
  max-height: 55vh;
  overflow-y: auto;
  padding-right: 0.25rem;
}
.direct-report-actions {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0.35rem 0 0.25rem;
  gap: 0.5rem;
  align-items: center;
}
.direct-report-search {
  flex: 1;
  min-width: 0;
  position: relative;
}
.direct-report-search.p-input-icon-left {
  display: block;
  width: 100%;
}
.direct-report-search input {
  width: 100%;
  padding-left: 2rem;
  padding-right: 2rem;
}
.direct-report-search .pi {
  position: absolute;
  left: 0.6rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
.direct-report-search .pi-times {
  left: auto;
  right: 0.6rem;
  pointer-events: auto;
  cursor: pointer;
}
.direct-report-sort {
  min-width: 10rem;
  flex: 0 0 auto;
}
.weeklySummaryGrid {
  margin-top: 0.5rem;
}
.weekly-summary-sticky {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--surface-card);
  padding-top: 0.5rem;
}
.weekly-summary-panel {
  margin-top: 0.75rem;
}
.weekly-summary-panel .p-panel-header {
  background: var(--surface-100);
  border: 1px solid var(--surface-border);
}
.weekly-summary-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  justify-content: space-between;
}
.weekly-summary-metrics {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.summary-metric {
  background: var(--surface-200);
  color: var(--text-color);
  border-radius: 999px;
  padding: 0.15rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}
.weekly-summary-body {
  padding-top: 0.5rem;
}
@media (max-width: 1100px) {
  .timecard-layout {
    flex-direction: column;
  }
  .timecard-layout-left,
  .timecard-layout-right {
    max-width: 100%;
    width: 100%;
    flex: 1 1 auto;
    min-width: 0;
  }
  .direct-report-panel {
    max-height: 27vh;
    overflow: auto;
  }
}
.direct-report-card {
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  background: var(--surface-card);
  overflow: hidden;
}
.direct-report-card.is-selected {
  box-shadow: 0 0 0 2px var(--primary-color);
}
.direct-report-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0.4rem 0.6rem;
  border: none;
  background: var(--surface-100);
  color: var(--text-color);
  text-align: left;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.direct-report-header-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.direct-report-select {
  display: inline-flex;
  align-items: center;
}
.direct-report-title {
  font-weight: 600;
  min-width: 0;
  flex: 1;
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.direct-report-status {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  width: 100%;
  margin-top: 0.5rem;
}
.direct-report-status.compact {
  gap: 0.25rem;
  margin-top: 0.35rem;
}
.direct-report-status.compact .status-row {
  font-size: 0.7rem;
  padding: 0.1rem 0.35rem;
  min-width: 0;
  flex: 1 1 auto;
}
.direct-report-status.compact .status-label {
  margin-right: 0.25rem;
}
.status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  border: 1px solid;
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  background-color: var(--surface-50);
  transition: all 0.2s ease;
  flex: 1 1 0;
  min-width: 100px;
  white-space: nowrap;
  overflow: hidden;
}
.status-row.status-selected {
  border-width: 0;
}
.status-label {
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.status-hours {
  font-weight: 700;
  font-size: 0.95rem;
  margin-left: 0.5rem;
  min-width: 2.5rem;
  text-align: right;
  flex-shrink: 0;
}
.direct-report-body {
  padding: 0.3rem 0.5rem 0.5rem;
  background: var(--surface-card);
}
.direct-report-details {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}
.detail-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.85rem;
}
.detail-label {
  color: var(--text-color-secondary);
  min-width: 9rem;
}
.direct-report-empty {
  padding: 0.75rem;
  color: var(--text-color-secondary);
}
/*# sourceMappingURL=time-card-presenter.component.css.map */
